import { render, staticRenderFns } from "./EditScheduledDocumentTemplate.vue?vue&type=template&id=06b51254&"
import script from "./EditScheduledDocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./EditScheduledDocumentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditScheduledDocumentTemplate.vue?vue&type=style&index=0&id=06b51254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports